module.exports = __webpack_public_path__ + "static/media/portFolioTransaction.d86e2d22.svg";